var n = (a, e, o) => new Promise((s, c) => {
  var i = (t) => {
    try {
      l(o.next(t));
    } catch (r) {
      c(r);
    }
  }, m = (t) => {
    try {
      l(o.throw(t));
    } catch (r) {
      c(r);
    }
  }, l = (t) => t.done ? s(t.value) : Promise.resolve(t.value).then(i, m);
  l((o = o.apply(a, e)).next());
});
import { selfAxios as f } from "@oppein/op-utils";
function g(a) {
  return n(this, null, function* () {
    const {
      data: e
    } = yield f.get(
      "/bsplatform/external/commodity/selectPlate",
      { params: a }
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  g as getSelectPlate
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/external/commodity/selectPlate/get.js
// module id = 1755
// module chunks = 41